import React, { useState, useEffect, useContext, useRef } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { FaGraduationCap, FaArrowRight } from "react-icons/fa";
import "../styles/education.css";
import Account from "../components/Account";

const Education = () => {
  const { purchaseEducationToken, fetchNotifications } = useContext(AuthContext);
  const navigate = useNavigate();

  const [eduType, setEduType] = useState('');
  const [selectedBundle, setSelectedBundle] = useState(null);
  const [bundles, setBundles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const eduTypeRef = useRef();
  const bundleRef = useRef();

  const pricePlans = [
    {
      SERVICE: 'NECO',
      BUNDLE: [
        { eduCode: 'NEONE', status: 'Active', price: '`1500' },
        { eduCode: 'NETWO', status: 'Active', price: '3000' },
        { eduCode: 'NETHR', status: 'Active', price: '4500' },
        { eduCode: 'NEFOUR', status: 'Active', price: '6000' },
        { eduCode: 'NEFIVE', status: 'Active', price: '7500' },
      ],
    },
    {
      SERVICE: 'WAEC',
      BUNDLE: [
        { eduCode: 'WAONE', status: 'Active', price: '3900' },
        { eduCode: 'WATWO', status: 'Active', price: '7800' },
        { eduCode: 'WATHR', status: 'Active', price: '11700' },
        { eduCode: 'WAFOUR', status: 'Active', price: '15600' },
        { eduCode: 'WAFIVE', status: 'Active', price: '19500' },
      ],
    },
  ];

  useEffect(() => {
    if (eduType) {
      const selectedService = pricePlans.find((service) => service.SERVICE === eduType);
      if (selectedService) {
        setBundles(selectedService.BUNDLE);
      }
    }
  }, [eduType]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors({});
    const newErrors = {};

    if (!eduType) {
      newErrors.eduType = "Please select education type.";
    }

    if (!selectedBundle) {
      newErrors.selectedBundle = "Please select a bundle.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);

      const firstErrorRef = newErrors.eduType
        ? eduTypeRef
        : bundleRef;

      setTimeout(() => {
        firstErrorRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);

      return;
    }

    navigate("/review", {
      state: {
        type: "education",
        details: {
          eduCode: selectedBundle.eduCode,
          price: selectedBundle.price,
          eduType,
        },
      },
    });
  };

  return (
    <div>
      <Account />
      <div className="shadow-md">
        <form onSubmit={handleSubmit} className="edu-form space-y-3">

          <div className='dropdown-selector' ref={eduTypeRef}>
            <label className='styled-label'>Education Type</label>
            <select
              value={eduType}
              onChange={(e) => setEduType(e.target.value)}
              className="styled-select styled-input"
            >
              <option value="">Select Education Type</option>
              <option value="NECO">NECO</option>
              <option value="WAEC">WAEC</option>
            </select>
            {errors.eduType && <div className="error-input">{errors.eduType}</div>}
          </div>

          {eduType && (
            <div className="dropdown-selector" ref={bundleRef}>
              <label>Choose Bundle</label>
              <select
                value={selectedBundle?.eduCode || ''}
                onChange={(e) => {
                  const selected = bundles.find(
                    (bundle) => bundle.eduCode === e.target.value
                  );
                  setSelectedBundle(selected);
                }}
                className="styled-select styled-input"
              >
                <option value="">Select Bundle</option>
                {bundles.map((bundle) => (
                  <option key={bundle.eduCode} value={bundle.eduCode}>
                    {bundle.eduCode} - ₦{bundle.price}
                  </option>
                ))}
              </select>
              {errors.selectedBundle && <div className="error-input">{errors.selectedBundle}</div>}
            </div>
          )}

          <button type="submit" className="bulk-btn" disabled={loading}>
            {loading ? 'Processing...' : 'Buy Token'}
          </button>
        </form>

        <div className="">
          <Link to="/result-details" className="token-widget-link">
            <div className="token-widget-box">
              <span className="token-title">
                <FaGraduationCap className="token-icon" /> View My Education Token History
              </span>
              <span className="token-arrow">
                <FaArrowRight />
              </span>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Education;
